const auth = {
  errors: {
    handoff: {
      description: 'Esta sesión ya no se puede reanudar.',
      suggestion: 'Vuelva a Safety Center y abra una nueva sesión de chat.',
      suggestionHeading: 'Siguiente paso:',
      title: 'Enlace de sesión no disponible',
    },
    network: {
      description: 'No se puede conectar al servidor de chat.',
      suggestions: {
        connection: 'Compruebe que su conexión a Internet funciona.',
        retry: 'Inténtelo de nuevo en unos momentos.',
      },
      suggestionHeading: 'Qué puede intentar:',
      title: 'Fallo de conexión con el servidor',
    },
    server: {
      description: 'El servidor de chat tiene problemas.',
      suggestions: {
        refresh: 'Intente actualizar la página.',
        support: 'Contacte con soporte si el problema continúa.',
        wait: 'Espere unos momentos a que el servidor se recupere.',
      },
      suggestionHeading: 'Qué puede intentar:',
      title: 'Error del servidor',
    },
  },
  loading: {
    almostReady: 'Casi listo',
    initializing: 'Iniciando SpeedGauge Coach AI',
    preparingDashboard: 'Preparando su panel',
    securingConnection: 'Protegiendo su conexión',
    validatingCredentials: 'Validando credenciales',
  },
  actions: {
    returnToSafetyCenter: 'Volver a Safety Center',
    retryConnection: 'Intentar de nuevo',
    retryConnectionTitle: 'Intentar conectarse al servidor de nuevo',
    retryingConnection: 'Reintentando...',
    retryingConnectionLabel: 'Reintentando la conexión',
    returnToSafetyCenterTitle: 'Volver a Safety Center',
  },
  guard: {
    creatingSession: 'Creando su sesión...',
    redirectLoopDetected: 'No se pudo completar el inicio de sesión. Inténtelo de nuevo.',
    redirectingToSignIn: 'Redirigiendo para iniciar sesión...',
  },
  lastError: 'Último error: {{time}}',
  loadingSession: 'Cargando su sesión...',
  sessionUnavailable: 'Su sesión no está disponible. Inicie sesión de nuevo.',
} as const;

export default auth;